import { ShiftsView } from '@/domains/shifts/components/ShiftsView';
import { useCreateShift, useDeleteShift, useShifts } from '@/domains/shifts/hooks/useShifts';
import { useNavigate } from 'react-router';

export function ShiftsPage() {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useShifts();
  const createShift = useCreateShift();
  const deleteShift = useDeleteShift();

  return (
    <ShiftsView
      shifts={data?.values ?? []}
      totalCount={data?.count ?? 0}
      isLoading={isLoading}
      isError={isError}
      onShiftClick={(shiftId) => navigate(`/shifts/${shiftId}`)}
      onCreateShift={async (input) => {
        await createShift.mutateAsync(input);
      }}
      onDeleteShift={async (id) => {
        await deleteShift.mutateAsync(id);
      }}
    />
  );
}
